import React, { useState } from 'react';
import { FaMapMarkerAlt, FaEnvelope, FaPaperPlane } from 'react-icons/fa';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
    // You can add email functionality here
  };

  return (
    <div className="contact-section" id="contact">
      <div className="contact-container">
        <div className="contact-header">
          <h2>We'd Love to Hear From You</h2>
          <p>Get in touch with us for any inquiries or questions</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="info-item">
              <div className="info-icon">
                <FaMapMarkerAlt />
              </div>
              <div className="info-details">
                <h3>Address</h3>
                <p>2Q79+4H7, M1 Road</p>
                <p>NICO CENTRE BUILDING, SHOP #8</p>
                <p>GAME CAR PARK, OLD TOWN</p>
                <p>LILONGWE, MALAWI</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <FaEnvelope />
              </div>
              <div className="info-details">
                <h3>Email</h3>
                <a href="mailto:info@pharmacaremw.com">info@pharmacaremw.com</a>
              </div>
            </div>

            <div className="contact-map">
              <iframe
                title="Pharmacare Location"
                src="https://www.google.com/maps?q=2Q79+4H7,M1+Road,Lilongwe&output=embed"
                width="100%"
                height="400"
                style={{ border: 0, borderRadius: '10px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
              <a 
                href="https://maps.app.goo.gl/gcbjXFVt5BVng2HU8" 
                target="_blank" 
                rel="noopener noreferrer"
                className="view-larger-map"
              >
                View larger map
              </a>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="fullName">Full Name</label>
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Enter your full name"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Your message"
                  rows="5"
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                <FaPaperPlane /> Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;

